import { render, staticRenderFns } from "./TotalByLabsDialog.vue?vue&type=template&id=4686dd1e"
import script from "./TotalByLabsDialog.vue?vue&type=script&lang=js"
export * from "./TotalByLabsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports